import { render, staticRenderFns } from "./select-printer.vue?vue&type=template&id=36a9190a&scoped=true&"
import script from "./select-printer.vue?vue&type=script&lang=js&"
export * from "./select-printer.vue?vue&type=script&lang=js&"
import style0 from "./select-printer.vue?vue&type=style&index=0&id=36a9190a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9190a",
  null
  
)

export default component.exports